//define iris namespace
if (!('iris' in window)) window['iris'] = {};

iris.TicketFilters = {};

iris.TicketFilters.Initialise = function (options) {
    options = $.extend({}, {
        redirectUrl: "",
        includePagination: true
    }, options);

    let setLocation = function (querystring) {
        if (options.redirectUrl === "") {
            //reset page let
            delete querystring['page'];

            window.location.search = $.param(querystring);
        } else {
            window.location = options.redirectUrl + '?' + $.param(querystring);
        }
    };

    let showloader = function () {
        options.container.append(iris.loader.clone());
    };

    $(".filter-block").each(function () {
        let $this = $(this);

        //scan for buttons
        $this.find('button').on('click', function () {
            let $input = $(this).prevAll('input');
            let $value = $input.val();
            let $name = $input.attr('name');

            showloader();
            setLocation(iris.appendToUrl($name, $value));
        });

        //scan for dropdowns
        $this.find('select').on('change', function () {
            let $value = $(this).val();
            let $name = $(this).attr('name');

            showloader();
            setLocation(iris.appendToUrl($name, $value));
        });

        $this.find('a').on('click', function (e) {
            showloader();
        });
    });

    $('.filterbar a').on('click', function () {
        let $this = $(this);
        let $exp = $this.data('expression');
        let $params = iris.appendToUrl($exp, null);
        delete $params[$exp];

        showloader();
        setLocation($params);
    });

    //include pagination links
    if (options.includePagination) {
        options.container.find('.pagination a').click(function (e) {
            showloader();
        });
    }

    // current and previous month links
    $("#current_month").on('click', function (e) {
        let today = new Date();
        let year = today.getFullYear();
        let month = today.getMonth() + 1;

        e.preventDefault();
        $('#period').val(year + '-' + month.toString().padStart(2, '0'));
        $('#period').change();
    });

    $("#previous_month").on('click', function (e) {
        let today = new Date();
        let year = today.getFullYear();
        let month = today.getMonth();

        e.preventDefault();
        $('#period').val(year + '-' + month.toString().padStart(2, '0'));
        $('#period').change();
    });
};

/****************
 * Ticket events *
 *****************/
$('body').on('change', '#cred-usefrom', function (e) {
    $('#cred-useuntil').datepicker("option", "minDate", $(this).val());
});

$('body').on('change', '#cred-useuntil', function (e) {
    $('#cred-usefrom').datepicker("option", "maxDate", $(this).val());
});

$('body').on('change', 'select#customer', function () {
    $subscription = $('#subscription');
    $person = $('#person');

    //init with 'loading...' value
    $subscription.html('<option value="" selected disabled>Loading subscriptions...</option>').prop('disabled', 'disabled');
    $person.html('<option value="" selected disabled>Loading persons...</option>').prop('disabled', 'disabled');

    $subscription.populateFromUrl({
        url: "/lookup/subscriptions/" + $(this).val(),
        disableIfEmpty: true,
        emptyText: "No subscriptions found..."
    });
    $person.populateFromUrl({
        url: "/lookup/persons/" + $(this).val(),
        disableIfEmpty: true,
        emptyText: "No person available..."
    });
});

$('body').on('click', 'h4#headingOne', function () {
    if ($("div#collapseOne").hasClass("show")) {
        $("#cred-username").prop("disabled", true);
        $("#cred-password").prop("disabled", true);
    } else {
        $("#cred-username").prop("disabled", false);
        $("#cred-password").prop("disabled", false);
    }
})

$('body').on('click', '#ticket-reply-button', function (e) {
    $('#ticket-reply-form').submit();
});

$('body').on('click', '#question-button', function (e) {
    $('#question-form').submit();
});